<template>
  <div class="w-screen h-screen flex justify-center items-center">
    <div class="bg-white border rounded-lg p-10" style="width: 20%">
      <h1 class="mb-10">Login</h1>
      <label>Email address</label>
      <el-input class="mt-2 mb-10" v-model="formData.email" type="email" />

      <label>Password</label>
      <el-input
        class="mt-2 mb-10"
        v-model="formData.password"
        type="password"
        @keyup.native.enter="login"
      />

      <el-button class="w-full" type="primary" @click="login">Login</el-button>
    </div>
  </div>
</template>

<script>
import { LOGIN_MUTATION } from "@/api/mutations";

export default {
  data() {
    return {
      formData: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      const { data } = await this.$apollo.mutate({
        mutation: LOGIN_MUTATION,
        variables: this.formData
      });

      if (data.loginAdmin.status == 200) {
        this.$token = data.loginAdmin.token;
        await this.$store.dispatch("login", data.loginAdmin);
        this.$router.push({ name: "dashboard" });
      } else {
        this.toastMessage("Invalid username or password", "error");
      }
    }
  }
};
</script>
